import { useAuthContext } from "providers/Auth";
import { useOnboardingChecklistController } from "shared/queries/useOnboardingChecklistController";

// Shared with Layout, which reserves bottom padding while this is visible.
// Same query key, so it costs one request.
export const useOnboardingChecklistState = () => {
  const { type } = useAuthContext();

  const enabled = type.isOnboardingChecklist && type.adminPrivileges;

  const { checklistMeta } = useOnboardingChecklistController({ enabled });
  const checklist = checklistMeta.data;

  return {
    checklist,
    refetch: checklistMeta.refetch,
    isAvailable: enabled && !!checklist && checklist.total_count > 0
  };
};
